import React from 'react';
import block from 'bem-cn-lite';
import {UserDropdown, UserDropdownProps} from '@yandex-data-ui/common';
import {ClassNameProps} from '@yandex-data-ui/cloud-components';

import {compose} from 'recompose';
import withUser, {WithUserProps} from 'hoc/withUser';

import {checkIsAuthorized} from 'utils';

import './HeaderUser.scss';

const b = block('HeaderUser');

export interface HeaderUserOwnProps extends ClassNameProps {
    size?: UserDropdownProps['size'];
}

export type HeaderUserProps = HeaderUserOwnProps & WithUserProps;

const HeaderUser: React.FC<HeaderUserProps> = ({user, className, size}) => {
    const accounts = checkIsAuthorized(user.status)
        ? user.accounts.filter(({uid}) => uid !== user.uid)
        : [];

    return user.uid ? (
        <div className={b(null, className)}>
            <UserDropdown user={user} accounts={accounts} size={size} />
        </div>
    ) : null;
};

export default compose<HeaderUserProps, HeaderUserOwnProps>(withUser)(HeaderUser);
